import { IconButton, styled } from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 40

export const Button = styled(IconButton)(({ theme }) => ({
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    border: `1px solid ${theme.palette.primary.contrast}`,
    color: theme.palette.primary.contrast,
}))